import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Grid,
  LinearProgress,
  TablePagination,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CustomMenuList from "../../customComponents/CustomMenuList";
import ExamsScoreSheet from "./ExamsScoreSheet";
import { useParams } from "react-router-dom";
import { useGetClassesQuery } from "../classroom/classApiSlice";
import { useGetAssessmentsQuery } from "../settings/assessments/assessmentsApiSlice";
import { useGetTeacherSubjectsQuery } from "../staff/staffApiSlice";
import { preloadClassroom } from "../../../app/preloadService";
import { selectCurrentUser } from "../auth/authSlice";

const PER_PAGE = 10;

function ClassReportSheet() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { classId } = useParams();
  const [activeStudent, setActiveStudent] = useState(0);
  const [studentsPage, setStudentsPage] = useState(0);
  const [openStudents, setOpenStudents] = useState(!isMobile);
  const currentUser = useSelector(selectCurrentUser);
  const { data: mySubjects } = useGetTeacherSubjectsQuery();
  const { data: students, isLoading: getStudentsLoading } = useGetClassesQuery(
    `${classId}/students`
  );
  const { data: allAssessments, isLoading: loadingAssessments } =
    useGetAssessmentsQuery("all");
  const { data: classroom } = useGetClassesQuery(classId); //to get updated list of classrooms

  const subSectionAssessments = allAssessments?.filter(
    (assessment) => assessment.subsection_id === classroom?.subsection_id
  );

  useEffect(() => {
    if (!classId) return;
    const subjectIds = (mySubjects || [])
      .filter((s) => s.classroom_id === parseInt(classId))
      .map((s) => s.id);
    preloadClassroom(parseInt(classId), subjectIds, { auth: { user: currentUser } });
  }, [classId, currentUser, mySubjects]);

  const handleStudentChange = (idx) => {
    setActiveStudent(studentsPage * PER_PAGE + idx);
    if (isMobile) {
      setOpenStudents(false);
    }
  };

  return (
    <Grid container columnSpacing={3}>
      <Grid item xs={12} md={4} lg={4}>
        {isMobile ? (
          <Accordion
            expanded={openStudents}
            onChange={(_, expanded) => setOpenStudents(expanded)}
            disableGutters
            sx={{ mb: 1 }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Students</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              {getStudentsLoading && <LinearProgress />}
              <CustomMenuList
                activeTab={activeStudent - studentsPage * PER_PAGE}
                setActiveTab={handleStudentChange}
                heading="Students"
                list={students?.slice(studentsPage * PER_PAGE, (studentsPage + 1) * PER_PAGE)?.map(
                  (student) => student.first_name + " " + student.last_name
                )}
                icon={<Avatar />}
              />
              <TablePagination
                component="div"
                count={students?.length ?? 0}
                page={studentsPage}
                rowsPerPage={PER_PAGE}
                rowsPerPageOptions={[PER_PAGE]}
                onPageChange={(_, newPage) => setStudentsPage(newPage)}
              />
            </AccordionDetails>
          </Accordion>
        ) : (
          <>
            {getStudentsLoading && <LinearProgress />}
            <CustomMenuList
              activeTab={activeStudent - studentsPage * PER_PAGE}
              setActiveTab={handleStudentChange}
              heading="Students"
              list={students?.slice(studentsPage * PER_PAGE, (studentsPage + 1) * PER_PAGE)?.map(
                (student) => student.first_name + " " + student.last_name
              )}
              icon={<Avatar />}
            />
            <TablePagination
              component="div"
              count={students?.length ?? 0}
              page={studentsPage}
              rowsPerPage={PER_PAGE}
              rowsPerPageOptions={[PER_PAGE]}
              onPageChange={(_, newPage) => setStudentsPage(newPage)}
            />
          </>
        )}
      </Grid>

      <Grid item xs={12} md={8} lg={8}>
        <ExamsScoreSheet
          classId={classId}
          student={students ? students[activeStudent] : []}
          assessments={subSectionAssessments || []}
          
        />
      </Grid>
    </Grid>
  );
}

export default ClassReportSheet;
